import React, { useEffect } from 'react';
import {
  Paper, Box, Skeleton, Stack, alpha
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomChipComponent from '../../../core/components/common/custom-chip.component';
import CustomTypography from '../../../core/components/ui/CustomTypography';
import theme from '../../../core/components/layout/theme';
import CustomButton from '../../../core/components/ui/CustomButton';
import useDriver from '../hooks/useDriver';

export default function ViewDriverComponent() {
  const org_uid = new URLSearchParams(window.location.search).get('org_uid');
  const profile_uid = new URLSearchParams(window.location.search).get('profile_uid');

  const { businessViewDriver, viewDriver, loading } = useDriver();
  
  const navigate = useNavigate();

  useEffect(() => {
    if (org_uid || profile_uid) {
      businessViewDriver({ org_uid, profile_uid });
    }
  }, [org_uid, profile_uid]);

  const driverInfo = viewDriver?.user_info?.[0] || {};

  const renderRow = (label, value) => (
    <Box flex={1}>
      <CustomTypography variant="caption" text={label} />
      {loading ? (
        <Skeleton
          variant="text"
          height="35px"
          width="70%"
          sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.09) }}
        />
      ) : (
        <CustomTypography
          variant="body1"
          text={value}
          customStyles={{ fontWeight: 500 }}
        />
      )}
    </Box>
  );

  return (
    <>
    <CustomButton
        variant="text" 
        startIcon={<ArrowBackIcon fontSize="small" />}
        label="Back"
        customStyles={{fontSize: 14, mt: 2}}
        onClick={() => navigate(-1)}
    />
    <Paper elevation={0} sx={{ border: '1px solid #e5edf6', borderRadius: 2, p: 3, mt: 3 }}>
      <Box sx={{display:'flex', alignItems:'center', mb: 2}}>
      <CustomTypography
        variant="h3"
        text="Driver Profile"
        customStyles={{ fontSize: 20, fontWeight: 700 }}
      />
      <Box flex={1} />
      <Box mt={2}>
        {loading ? (
          <Skeleton
            variant="rounded"
            width={100}
            height={30}
            sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.09) }}
          />
        ) : (
          <CustomChipComponent
            category="profileStatusStyles"
            label={driverInfo?.status || 'Unknown'}
          />
        )}
      </Box>
      </Box>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {renderRow("Lastname", driverInfo?.lastname || 'N/A')}
        {renderRow("Firstname", driverInfo?.firstname || 'N/A')}
        {renderRow("Middlename", driverInfo?.middlename ?? 'N/A')}
        <Box flex={1} />
      </Stack>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {renderRow("Email", driverInfo?.email || 'N/A')}
        {renderRow("Contact Number", driverInfo?.contact_no ?? 'N/A')}
        {renderRow("Birthdate", driverInfo?.birthdate ? new Date(driverInfo.birthdate).toLocaleDateString() : 'N/A')}
        <Box flex={1} />
      </Stack>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {renderRow("Profile Type", viewDriver?.profile_type || 'N/A')}
        {renderRow("Role", viewDriver?.role || 'N/A')}
        {renderRow("Status", driverInfo?.status || 'N/A')}
        <Box flex={1} />
      </Stack>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {renderRow("ID Type", viewDriver?.id_type || 'N/A')}
        {renderRow("ID Number", viewDriver?.id_no || 'N/A')}
        {renderRow("Org UID", viewDriver?.org_uid || 'N/A')}
        <Box flex={1} />
      </Stack>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {renderRow("Created At", viewDriver?.created_at ? new Date(viewDriver.created_at).toLocaleString() : 'N/A')}
        <Box flex={1} />
      </Stack>

      
    </Paper>
    </>
  );
}
